import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};
`;

export const Option = styled.button<{ $selected: boolean }>`
  display: flex;
  align-items: center;
  gap: ${spacing[3]};
  width: 100%;
  padding: ${spacing[3]};
  text-align: left;
  cursor: pointer;
  border-radius: 0.5rem;
  border: 1px solid
    ${({ $selected }) => ($selected ? rawColors.brand.primary : rawColors.grey[300])};
  background: ${rawColors.structural.white};
  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const IconBox = styled.span<{ $selected: boolean }>`
  display: grid;
  place-items: center;
  flex: none;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  color: ${({ $selected }) => ($selected ? rawColors.structural.white : rawColors.text.mediumEmphasis)};
  background: ${({ $selected }) => ($selected ? rawColors.brand.primary : rawColors.primary[50])};
`;

export const Copy = styled.span`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`;

export const Title = styled.span`
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.highEmphasis};
  display: inline-flex;
  gap: ${spacing[2]};
  align-items: center;
`;

export const Description = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const Radio = styled.span<{ $selected: boolean }>`
  flex: none;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 50%;
  border: ${({ $selected }) => ($selected ? "0.3125rem" : "0.125rem")} solid
    ${({ $selected }) => ($selected ? rawColors.brand.primary : rawColors.grey[300])};
`;
